module.exports = __webpack_public_path__ + "img/display-1.5daa2098.svg";